import { ReportFeatures } from '@hcs/types';

export const SUBJECT_TRANSACTION_HISTORY_FEATURES = [
  ReportFeatures.SubjectTransactionHistory,
];
export const dataHcEventSectionSubjectTransactionHistorySale =
  'Subject Sale History';
export const dataHcEventSectionSubjectTransactionHistoryRental =
  'Subject Rental History';
